var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 36.6667H6.66667C5.7462 36.6667 5 35.9205 5 35V5.00004C5 4.07957 5.7462 3.33337 6.66667 3.33337H33.3333C34.2538 3.33337 35 4.07957 35 5.00004V35C35 35.9205 34.2538 36.6667 33.3333 36.6667ZM31.6667 33.3334V6.66671H8.33333V33.3334H31.6667ZM13.3333 15H26.6667V18.3334H13.3333V15ZM13.3333 21.6667H26.6667V25H13.3333V21.6667Z",
    fill: "#080A52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingStatus);
export default __webpack_public_path__ + "static/media/billing-status.62e4cf8cab0c0d4089da5b9c0e16d448.svg";
export { ForwardRef as ReactComponent };